<template>
  <div>
    <div v-if="flag.registedSubscription && ((['webPaper', 'paper'].includes(coursename) && step === 6) || (coursename === 'web' && step === 5))">
      <p>桐生タイムスの定期購読にお申し込みいただきありがとうございます！</p>
      <Spacer :y="6"/>
      <div :class="$style.btns">
        <button
          :class="[$style.btn, $style.primary]">
          <router-link to="/">トップページへ</router-link>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'edit-subscription-completed',
};
</script>

<style lang="scss" module="s">

</style>
